import { render, staticRenderFns } from "./WavesBackgroundTop.vue?vue&type=template&id=6f7cc05a"
import script from "./WavesBackgroundTop.vue?vue&type=script&lang=js"
export * from "./WavesBackgroundTop.vue?vue&type=script&lang=js"
import style0 from "./WavesBackgroundTop.vue?vue&type=style&index=0&id=6f7cc05a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports